import { EColorVariablesV2 } from '@/types/theme-packs.types';

const getThemeColorCSSVariable = (variableName?: EColorVariablesV2) => {
  return `var(--project-theme-color-${variableName || EColorVariablesV2.primary})`;
};

export default getThemeColorCSSVariable;
